// Stylised emoji art for the chat's reaction set: the same Twemoji glyphs
// Discord renders, bundled under public/emoji/twemoji (six files, see the
// LICENSE.md beside them). Upstream names files by codepoint, lower-case
// hex joined with '-', and drops the U+FE0F variation selector, so '❤️'
// resolves to 2764.svg.
export function twemojiUrl(emoji) {
  const codes = [];
  for (const ch of emoji) {
    const cp = ch.codePointAt(0);
    if (cp !== 0xfe0f) codes.push(cp.toString(16));
  }
  return `/emoji/twemoji/${codes.join('-')}.svg`;
}
